// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1_KIE","spin":"style_spin__21CSJ"};